export const ACTION_TYPE = 'actionType';
export const EVENT_FILTERS = 'eventFilters';
export const EXPIRATION = 'expiration';
export const TARGET_OBJECT_OVERRIDE = 'targetObjectOverride';
export const CONTINUE_IF_EVENT_HAS_ALREADY_OCCURRED = 'continueIfEventHasAlreadyOccurred';